import { render, staticRenderFns } from "./AuthTestimonialPanel.vue?vue&type=template&id=477b1d8a"
import script from "./AuthTestimonialPanel.vue?vue&type=script&lang=js"
export * from "./AuthTestimonialPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports